"use client";

import { useEffect, useRef } from "react";
import { track } from "@/lib/stats-client";

/**
 * Counts a view for each of these stars (their profiles' ids): their page's, or a video's they're in; and
 * for the video itself, which "Hot now" ranks by (lib/stats.ts, lib/hot.ts).
 */
export function StarViews({ ids, video }: { ids: string[]; video?: string }) {
  const key = [video ? `video:${video}` : "", ...ids].join(",");
  // Once per page (development runs effects twice).
  const counted = useRef<string | null>(null);
  useEffect(() => {
    if (!key || counted.current === key) return;
    counted.current = key;
    for (const id of key.split(",")) {
      if (id.startsWith("video:")) track("video", id.slice(6));
      else if (id) track("star", id);
    }
  }, [key]);
  return null;
}
